import { useEffect, useState } from "react"

import {
  useForm,
  usePayloadFormatters,
  useStepTransition
} from "@garantidos/hooks"
import { focusOnLogo } from "@garantidos/utils"

import validatorsDictionary from "pages/Proposal/hooks/validators"

import { ProposalContext, useProposalContext } from "contexts/proposal"

import { fields } from "./fields"
import * as trackers from "./trackings"

const useFinancingConditions = () => {
  const { form } = useForm({
    fields,
    context: ProposalContext,
    validatorsDictionary
  })

  const [financeExpensesIofMsg, setFinanceExpensesIofMsg] = useState("")

  const {
    stepInfo,
    proposalData,
    cpfData,
    fetchProposalData,
    sendProposalData,
    errorMessage,
    setErrorMessage,
    errorHandler,
    isLoading,
    checkFinanceIOF,
    setIsStepVisible
  } = useProposalContext()

  const { stepNavigator } = useStepTransition(setIsStepVisible)
  const { formatSendPayload } = usePayloadFormatters(fields)

  const { previousStep, nextStep } = stepInfo
  const { hashedCpf } = cpfData

  const { partnerMaritalStatus } = fields

  const { finance_iof } = proposalData

  useEffect(() => {
    trackers.pageview(hashedCpf)
    trackers.iof(hashedCpf, !finance_iof)
  }, [])

  const handleRadioRequest = async (value) => {
    if (!value) {
      setFinanceExpensesIofMsg("")
      return
    }
    try {
      const financeExpenseIofResponse = await checkFinanceIOF({})

      if (financeExpenseIofResponse) {
        setFinanceExpensesIofMsg(financeExpenseIofResponse)
      }
      trackers.iof(hashedCpf, finance_iof)
    } catch (error) {
      errorHandler(error)
      setFinanceExpensesIofMsg("")
    }
  }

  const handleReferralClick = (value) => {
    trackers.referral(value, hashedCpf)
  }

  const onSubmitCallback = async (formData) => {
    try {
      const formattedFields = formatSendPayload(formData)
      const payload = formattedFields
      await sendProposalData({ payload })
      trackers.advance(hashedCpf)
      stepNavigator("next", nextStep)
    } catch (error) {
      errorHandler(error)
    }
  }

  const handlePrevStep = async () => {
    if (isLoading) return
    try {
      await fetchProposalData({ step: previousStep, recaptcha: true })
      trackers.back(hashedCpf)
      stepNavigator("prev", previousStep)
    } catch (error) {
      errorHandler(error)
    }
  }

  useEffect(() => {
    focusOnLogo()
  }, [])

  return {
    handlePrevStep,
    onSubmitCallback,
    fields,
    form,
    proposalData,
    handleRadioRequest,
    errorMessage,
    setErrorMessage,
    partnerMaritalStatus,
    financeExpensesIofMsg,
    handleReferralClick,
    isLoading
  }
}

export default useFinancingConditions
